import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import { PaymentStatusBadge, StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoyaltyPointsHistory,
  resetFilters,
  setFilter,
} from "store/slices/customersSlice";
import { ORDER_BY_OPTIONS, REFERRAL_SOURCE_OPTIONS, REFERRAL_TYPE_OPTIONS } from "utils/constants";
import { getActionFlags } from "utils/getActionFlags";
import { CurrencySymbol, formatUTCDate, getMinMaxDate } from "utils/utils";

const LoyaltyPointsHistory = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    loading2,
    loyaltyPointsHistory,
    filters: { loyaltyPointKeyword, dates, status, orderBy, source ,type },
  } = useSelector((state) => state.Customers);
  const { noTransactions } = Icons || {};
  useEffect(() => {
    getAllData();
  }, []);
  const getAllData = (page, action) => {
    const { isReset, isResetKeyword } = getActionFlags(action);

    const payload = {
      perPage: 100,
      pageNo: page || 1,
      orderBy: isReset ? -1 : orderBy,
      source: isReset ? "" : source,
      type: isReset ? "" : type,
      userId: id ?? "",
      keyword: isResetKeyword ? "" : loyaltyPointKeyword || "",
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };

    dispatch(getLoyaltyPointsHistory(payload));
  };
  const filtersList = [
    {
      key: "orderBy",
      placeholder: t("Order By"),
      type: "singleSelect",
      options: ORDER_BY_OPTIONS,
    },
    {
      key: "type",
      placeholder: t("Referral Type"),
      type: "singleSelect",
      options: REFERRAL_TYPE_OPTIONS,
    },
    {
      key: "source",
      placeholder: t("Source"),
      type: "singleSelect",
      options: REFERRAL_SOURCE_OPTIONS,
    },
  ];

  const columns = useMemo(
    () => [
      {
        header: t("Total Points"),
        key: "points",
        render: (value) => (
          <p className="">
            {value === 0 ? "0" : value}
          </p>
        ),
      },
      {
        header: t("Used Points"),
        key: "pointsUsed",
        render: (value) => (
          <p className="">
            {value === 0 ? "0" : value}
          </p>
        ),
      },
      {
        header: t("Available Points"),
        key: "pointsAvailable",
      },
      {
        header: t("Referral Type"),
        key: "type",
      },
      {
        header: t("Referral Source"),
        key: "source",
      },
      {
        header: t("Remarks"),
        key: "remarks",
      },
      {
        header: t("Created Date"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Expire Date"),
        key: "expiresAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
    ],
    [t],
  );
  const handleReset = () => {
    dispatch(resetFilters());
    getAllData(1, { actionType: "RESET" });
  };

  return (
    <div className="p-4">
      <FilterBar
        keyword={loyaltyPointKeyword}
        setKeyword={(value) => dispatch(setFilter({ key: "loyaltyPointKeyword", value }))}
        keywordPlaceholder={t("Search by referral Code")}
        filters={filtersList}
        selectedFilters={{ loyaltyPointKeyword, status, orderBy,source ,type }}
        onFilterUpdate={(key, value) => dispatch(setFilter({ key, value }))}
        onSearch={getAllData}
        onReset={handleReset}
        isDateRange={true}
        dates={dates}
        setDates={(value) => dispatch(setFilter({ key: "dates", value }))}
        isSearchEnabled={false}
      />
      {loading2 && <TableShimmer rows={12} columns={8} />}

      {!loading2 && loyaltyPointsHistory?.length === 0 && (
        <NoDataFound title={t("No history found")} icon={noTransactions} />
      )}

      {!loading2 && loyaltyPointsHistory?.length > 0 && (
        <DataTable columns={columns} data={loyaltyPointsHistory} t={t} />
      )}
    </div>
  );
};

export default LoyaltyPointsHistory;
